import {connect} from "react-redux";
import ViewListing from './View'
import {bindActionCreators} from "redux";
import {getTaskById, removeTask} from "../../../service/Task/action";

const mapStateToProps = (state) => ({
    taskDetailsById:state.Task.taskDetailsById,
    removeTaskDetails:state.Task.removeTask,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getTaskById,
            removeTask
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ViewListing);
